'use strict';

export class UserInfoCard {
    constructor(id) {
        this.id = id;
        this.root = document.querySelector(`.js-${id}`);
        this.init();
    }

    init() {
        if (!this.root) return;

        this.root.querySelectorAll('.js-share').forEach(btn => {
            btn.addEventListener('click', () => {
                if (navigator.share) {
                    navigator.share({
                        title: 'Check out this profile',
                        url: window.location.href
                    });
                }
            });
        });

        this.setupAvatarUpload();

        this.root.querySelectorAll('.js-profile_menu_action').forEach(btn => {
            btn.addEventListener('click', (e) => this.handleFollowAction(e.currentTarget));
        });
    }

    handleFollowAction(element) {
        if (!yalwa.basics.readonly_check()) {
            return false;
        }
        let action = element.getAttribute('data-action');
        const userID = element.getAttribute('data-userid');

        if (action === 'following') {
            action = 'unfollow';
        }

        jQuery.ajax({
            url: '/api/ajax/follow_user',
            type: 'post',
            dataType: 'json',
            data: {
                action: action,
                userID: userID
            }
        }).done(response => {
            if (response.success) {
                yalwa.basics.toast({message: response.message, type: 'success'});

                const followBtns = this.root.querySelectorAll('.js-profile_menu_action[data-action="follow"]');
                const followingBtns = this.root.querySelectorAll('.js-profile_menu_action[data-action="following"]');

                if (action === 'follow') {
                    followBtns.forEach(btn => btn.classList.add('hidden'));
                    followingBtns.forEach(btn => btn.classList.remove('hidden'));
                    this.updateFollowersCounter(1);
                } else {
                    followBtns.forEach(btn => btn.classList.remove('hidden'));
                    followingBtns.forEach(btn => btn.classList.add('hidden'));
                    this.updateFollowersCounter(-1);
                }
            } else {
                const errorMsg = (yalwa.v.lang && yalwa.v.lang.an_error_occurred) ? yalwa.v.lang.an_error_occurred : 'An error occurred';
                yalwa.basics.toast({message: errorMsg, type: 'error'});
            }
        });
    }

    updateFollowersCounter(count) {
        const counter = this.root.querySelector('.js-followers_counter');
        if (counter) {
            counter.textContent = parseInt(counter.textContent) + count;
        }
    }

    setupAvatarUpload() {
        const editIcon = this.root.querySelector('.js-userinfocard__edit_icon, .userinfocard__edit_icon');
        if (!editIcon) return;

        editIcon.addEventListener('click', () => {
            const fileInput = document.createElement('input');
            fileInput.type = 'file';
            fileInput.accept = 'image/*';
            fileInput.style.display = 'none';
            
            fileInput.addEventListener('change', (event) => {
                this.handleAvatarUpload(event.target.files[0]);
            });

            document.body.appendChild(fileInput);
            fileInput.click();
            document.body.removeChild(fileInput);
        });
    }

    handleAvatarUpload(file) {
        if (!file) return;

        const formData = new FormData();
        formData.append('avatar', file);

        fetch('/api/ajax/avatar_upload', {
            method: 'POST',
            body: formData,
            credentials: 'include'
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then(data => {
            console.log('Upload response:', data);
            
            let errors = [];
            if (data.errors) {
                try {
                    errors = JSON.parse(data.errors);
                } catch (e) {
                    errors = [data.errors];
                }
            }
            
            if (errors && errors.length > 0) {
                console.error('Upload failed:', errors);
                return;
            }

			if (!data.image_url) {
				console.error('Upload failed: No image_url in response');
				return;
			}

			if (data.vip_completion) {
				document.dispatchEvent(new CustomEvent('vip_guide_state', {detail: data.vip_completion}));
			}

            const avatarImg = this.root.querySelector('.userinfocard__avatar');
            if (avatarImg) {
                avatarImg.src = data.image_url;
                this.showUploadSuccess(data.label_success_title, data.label_success_body);
            }
        })
        .catch(error => {
            console.error('Upload error:', error);
        });
    }

    showUploadSuccess(title, message) {
        yalwa.basics.toast({
            title: title,
            message: message,
            type: 'success',
            timeOut: 2000
        });
    }
}

// Auto-init instances
Object.keys(yalwa.v.components).forEach(key => {
    if (key.startsWith('userinfocard_')) {
        new UserInfoCard(key);
    }
});